<template>
  <section class="relative overflow-hidden rounded border-slate-200 bg-black text-white p-3 py-6">
    <div class="relative z-20">
      <p class="text-center text-sm text-slate-500">
        {{ useDate(game?.startDate).format('HH:mm ddd D MMM YYYY') }}
      </p>
      <div class="mt-4 grid grid-cols-[1fr_auto_1fr] items-center gap-3">
        <div class="flex flex-col items-center text-center relative">
          <NuxtLink class="absolute top-0 left-0 w-full h-full" :to="{ name: 'team', params: { team: home?.slug }}" v-if="home?.active" />
          <div class="flex h-20 w-20 items-center justify-center p-2 md:h-24 md:w-24 lg:h-28 lg:w-28">
            <TeamLogo
              v-if="home?.slug"
              class="block h-full w-full"
              :name="home?.name"
              :slug="home?.slug"
              :logo="home?.logo"
              size="512"
              :alt="home?.abbr"
            />
            <div v-else class="flex h-full w-full items-center justify-center rounded-full bg-slate-700 text-lg font-bold text-slate-300">
              H
            </div>
          </div>
          <p class="font-bold text-sm md:text-lg mt-3 line-clamp-1 text-white">{{ home?.name }}</p>
        </div>
        <div class="text-center text-white">
          <div class="" v-if="statusKey === 'upcoming'">
            <div class="text-5xl font-bold leading-none">
              {{ useDate(game?.startDate).format('HH:mm') }}
            </div>
            <div class="font-bold max-md:text-sm mt-1" v-if="!useDate(game?.startDate).isToday()">
              {{ useDate(game?.startDate).fromNow() }}
            </div>
          </div>
          <div class="text-5xl font-bold leading-none md:text-7xl" v-else>
            <span>{{ game?.result?.home || 0 }}</span>
            <span class="opacity-50 w-12 inline-block text-center">-</span>
            <span>{{ game?.result?.away || 0 }}</span>
          </div>
          <p v-if="statusKey !== 'upcoming' && game.periods?.p1" class="font-bold md:text-lg">
            ({{ game.periods?.p1?.home }} - {{ game.periods?.p1?.away }})
          </p>
          <div class="flex justify-center mt-2 md:mt-4 max-md:-mb-4">
            <span class="rounded border border-slate-500 py-1.5 w-24 text-center text-xs uppercase" :class="statusClass">
              {{ $t(`shared.game.status.${statusKey}`) }}
            </span>
          </div>
        </div>
        <div class="flex flex-col items-center text-center relative">
          <NuxtLink class="absolute top-0 left-0 w-full h-full" :to="{ name: 'team', params: { team: away?.slug }}" v-if="away?.active" />
          <div class="flex h-20 w-20 items-center justify-center p-2 md:h-24 md:w-24 lg:h-28 lg:w-28">
            <TeamLogo
              v-if="away?.slug"
              class="block h-full w-full"
              :name="away?.name"
              :slug="away?.slug"
              :logo="away?.logo"
              size="512"
              :alt="away?.abbr"
            />
            <div v-else class="flex h-full w-full items-center justify-center rounded-full bg-slate-700 text-lg font-bold text-slate-300">
              A
            </div>
          </div>
          <p class="font-bold text-sm md:text-lg mt-3 line-clamp-1 text-white">{{ away?.name }}</p>
        </div>
      </div>
      <div class="space-y-1 text-center mt-6">
        <div class="font-bold text-sm md:text-xl">
          {{ game.season?.name }}
        </div>
        <div class="text-sm">
          <!-- TODO: add stadium -->
          {{ game.stadium?.label }}
        </div>
      </div>
    </div>
    <img class="absolute z-10 top-0 left-0 w-full h-full opacity-40" src="~/assets/images/hero-football.jpg">
  </section>
</template>

<script setup>
const props = defineProps({
  game: {
    type: Object,
    default: () => ({})
  }
})

const home = computed(() => props.game?.home)
const away = computed(() => props.game?.away)

const statusKey = computed(() => {
  if (['ft', 'finished', 'full-time', 'fulltime'].includes(props.game.status)) return 'finished'
  if (['live', 'inplay', 'in-play'].includes(props.game.status)) return 'live'
  if (['ht', 'half-time', 'halftime'].includes(props.game.status)) return 'halfTime'
  return 'upcoming'
})

const statusClass = computed(() => {
  if (statusKey.value === 'live') return 'border-emerald-400/70 bg-emerald-500/10 text-emerald-300'
  if (statusKey.value === 'halfTime') return 'border-amber-400/70 bg-amber-500/10 text-amber-300'
  if (statusKey.value === 'finished') return 'border-slate-400/70 bg-slate-700/40 text-slate-100'
  return ''
})
</script>
